<!-- Filter -->
@if (showFilter) {
  <div class="row table-filter">
    <div class="d-md-flex">
      <div class="col-12 col-md-9">
        <mat-form-field class="search-form-field col-12" appearance="outline">
          <input (keyup)="filterTable()" [(ngModel)]="searchKey" autocomplete="off" matInput placeholder="{{'Search'}}" />
          @if (searchKey) {
            <button (click)="onSearchClear()" mat-icon-button matSuffix type="button">
              <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <div class="d-flex justify-content-center justify-content-md-end">
          @if (showDownloadButtons) {
            <button mat-icon-button type="button" matTooltip="{{'Copy table'}}" (click)="copyTable()">
              <mat-icon svgIcon="copy"></mat-icon>
            </button>
          }
          @if (showDownloadButtons) {
            <button mat-icon-button type="button" matTooltip="{{'Export' }}" (click)="downloadExcelFile()">
              <mat-icon svgIcon="excel"></mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
<!-- end of Filter -->


<div class="">

  <table cdk-table [dataSource]="listData" class="bg-white table mb-0" matSort id="table">

    @for (columnKey of cacheTableColumnKeywords; track columnKey; let i = $index) {
      @if (i == 0) {
        <!-- SN Column -->
        @if (!showCheckbox) {
          <ng-container matColumnDef="{{columnKey}}">
            <th cdk-header-cell *matHeaderCellDef mat-sort-header> {{columnHeader[columnKey]}} </th>
            <td cdk-cell *matCellDef="let element; let i = index">
              <span class="d-md-none d-block table-header-sm">{{ columnHeader[columnKey] }}</span>
              {{i + 1 + myPaginator.pageIndex * myPaginator.pageSize}}
            </td>
          </ng-container>
        }
        <!-- end of SN Column -->
        <!-- checkbox-->
        @if (showCheckbox) {
          <ng-container matColumnDef="{{columnKey}}">
            <th *matHeaderCellDef mat-header-cell>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [aria-label]="checkboxLabel()"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td *matCellDef="let row" mat-cell>
              <mat-checkbox (change)="$event ? selection.toggle(row) : null"
                (click)="$event.stopPropagation()"
                [aria-label]="checkboxLabel(row)"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>
        }
        <!--     end of checkbox-->
      }
      @if (!hasActionsColumn) {
        @if ((i > 0)) {
          <ng-container matColumnDef="{{columnKey}}">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{columnHeader[columnKey]}} </th>
            <td mat-cell *matCellDef="let element" class="text-wrap">
              <span class="d-md-none d-block table-header-sm">{{ columnHeader[columnKey] }}</span>
              <span [innerHTML]="settingsService.getTableObjectValue(element, columnKey)" class="text-wrap"></span>
            </td>
          </ng-container>
        }
      }
      @if (hasActionsColumn) {
        @if ((i > 0) && (i < ( (cacheTableColumnKeywords)?.length - 1))) {
          <ng-container matColumnDef="{{columnKey}}">
            <th mat-header-cell *matHeaderCellDef  mat-sort-header>{{columnHeader[columnKey]}} </th>
            <td mat-cell *matCellDef="let element" class="text-wrap">
              <span class="d-md-none d-block table-header-sm">{{ columnHeader[columnKey]}}</span>
              <span [innerHTML]="settingsService.getTableObjectValue(element, columnKey)" class="text-wrap"></span>
            </td>
          </ng-container>
        }
        @if (i == ( (cacheTableColumnKeywords)?.length - 1)) {
          <ng-container matColumnDef="{{columnKey}}">
            <th mat-header-cell  *matHeaderCellDef  mat-sort-header>{{columnHeader[columnKey]}} </th>
            <td mat-cell *matCellDef="let row">
              <ng-container [ngTemplateOutletContext]="{data : row}" [ngTemplateOutlet]="actions"></ng-container>
            </td>
          </ng-container>
        }
      }
    }


    <!-- Table Configurations -->
    <tr  cdk-header-row *matHeaderRowDef="cacheTableColumnKeywords"></tr>
    <tr cdk-row (click)="selection.toggle(row)" *matRowDef="let row; columns: cacheTableColumnKeywords;"></tr>
    <!-- end of Table Configurations -->

    <!-- If No Data Found -->
    @if ((listData != null && listData?.data?.length == 0)) {
      No data
    }

    <!-- end if no Data Found -->

    <!-- Loading Data Message -->
    @if (showLoading) {
      <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: listData != null }"></mat-footer-row>
      <ng-container matColumnDef="loading">
        <mat-footer-cell *matFooterCellDef>{{'loading'}}</mat-footer-cell>
      </ng-container>
    }
    <!-- end of Loading Data Message -->

  </table>

  <mat-paginator #myPaginator
               [pageSize]="pageSize"
               [pageSizeOptions]="pageSizeOptions"
               [length]="pageLength"
               [pageIndex]="pageIndex"
               showFirstLastButtons
               (page)="onPageChange($event)">
</mat-paginator>
</div>
